export const notificacoesMock = [
  {
    id: '1',
    tipo: 'carta_entregue',
    titulo: 'Sua carta está disponível!',
    descricao: 'A carta "Reflexões de Dezembro" já pode ser lida.',
    dataHora: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    lida: false,
    icone: 'ri-mail-open-line',
    cor: '#D4AF37'
  },
  {
    id: '2',
    tipo: 'lembrete_entrega',
    titulo: 'Carta chegando em breve',
    descricao: 'Sua próxima carta será entregue em 3 dias.',
    dataHora: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
    lida: false,
    icone: 'ri-time-line',
    cor: '#D4AF37'
  },
  {
    id: '3',
    tipo: 'pagamento_confirmado',
    titulo: 'Pagamento confirmado',
    descricao: 'Seu plano Premium foi renovado com sucesso.',
    dataHora: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
    lida: true,
    icone: 'ri-check-double-line',
    cor: '#10B981'
  },
  {
    id: '4',
    tipo: 'boas_vindas',
    titulo: 'Bem-vindo ao Cartas do Futuro!',
    descricao: 'Estamos felizes em tê-lo conosco nesta jornada de autoconhecimento.',
    dataHora: new Date(Date.now() - 48 * 60 * 60 * 1000).toISOString(),
    lida: true,
    icone: 'ri-heart-line',
    cor: '#EF4444'
  },
  {
    id: '5',
    tipo: 'atualizacao_sistema',
    titulo: 'Nova funcionalidade disponível',
    descricao: 'Agora você pode adicionar áudios às suas cartas!',
    dataHora: new Date(Date.now() - 72 * 60 * 60 * 1000).toISOString(),
    lida: true,
    icone: 'ri-notification-3-line',
    cor: '#3B82F6'
  },
  {
    id: '6',
    tipo: 'carta_entregue',
    titulo: 'Carta "Metas de 2025" disponível',
    descricao: 'Uma nova carta está esperando por você.',
    dataHora: new Date(Date.now() - 96 * 60 * 60 * 1000).toISOString(),
    lida: true,
    icone: 'ri-mail-open-line',
    cor: '#D4AF37'
  },
  {
    id: '7',
    tipo: 'lembrete_entrega',
    titulo: 'Não esqueça sua próxima carta',
    descricao: 'Sua carta será entregue amanhã às 10h.',
    dataHora: new Date(Date.now() - 120 * 60 * 60 * 1000).toISOString(),
    lida: true,
    icone: 'ri-time-line',
    cor: '#D4AF37'
  }
];

export type TipoNotificacao = 'carta_entregue' | 'lembrete_entrega' | 'pagamento_confirmado' | 'boas_vindas' | 'atualizacao_sistema' | 'todos';

export interface Notificacao {
  id: string;
  tipo: string;
  titulo: string;
  descricao: string;
  dataHora: string;
  lida: boolean;
  icone: string;
  cor: string;
}